import { Offer } from "@/js/resources";
import React from "react";
import { useTranslation } from "react-i18next";
import OfferComponent from "../Offer";
import PlanFrame from "../PlanFrame";

export default function SelectPlan({className, privateOffer, offers, loggedIn, onClickOffer, onRejectPrivateOffer}: {
    className?: string,
    privateOffer?: Offer | null,
    offers: Offer[],
    loggedIn?: boolean,
    onClickOffer?: (id: number) => void | Promise<void>,
    onRejectPrivateOffer?: () => void
}) {
    const {t} = useTranslation();

    return (
        <PlanFrame className={className} title={t("selectPlan.planTitle")}>
            <div className="mt-12 flex flex-wrap items-start gap-10 self-stretch justify-center">
                {privateOffer !== undefined ? (privateOffer !== null && (
                    <OfferComponent className="max-w-100 w-full" offer={privateOffer} onClick={onClickOffer && (() => onClickOffer(privateOffer.id))} onReject={onRejectPrivateOffer} loggedIn={loggedIn} />
                )) : offers.map((offer) => (
                    <OfferComponent className="max-w-100 w-full" key={offer.id} offer={offer} onClick={onClickOffer && (() => onClickOffer(offer.id))} />
                ))}
            </div>
        </PlanFrame>
    )
}